import { render, staticRenderFns } from "./DataTable.vue?vue&type=template&id=6b54ad4f"
import script from "./DataTable.vue?vue&type=script&lang=ts"
export * from "./DataTable.vue?vue&type=script&lang=ts"
import style0 from "./DataTable.vue?vue&type=style&index=0&id=6b54ad4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports